export const ASSIGNEE_OPTIONS = [
  { label: 'User', value: 'user' },
  { label: 'Squad', value: 'squad' },
  { label: 'Escalation Policy', value: 'escalationpolicy' },
];
